<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Testkort'" :sub-title="title" :title-id="title_id">
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'testcards.list' }" icon="icon-circle-left2">Tillbaka till lista</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div v-if="!initialized && busy_loading" class="content">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else-if="!not_found && test_card" class="content">
            <div class="row">
                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <ValidationObserver ref="testcardform">
                                <form @submit.prevent="saveTestCard">
                                    <input-with-validation
                                        vid="alias"
                                        v-model="test_card.alias"
                                        rules="required|max:64"
                                        label="Alias"
                                    ></input-with-validation>

                                    <input-with-validation
                                        vid="CardUID"
                                        v-model="test_card.CardUID"
                                        rules="required|max:32"
                                        label="CardUID"
                                    ></input-with-validation>

                                    <select-with-validation
                                        vid="test_mode"
                                        v-model="test_card.test_mode"
                                        label="TestMode"
                                        :options="test_modes"
                                        :reduce="(option) => option.value"
                                    ></select-with-validation>
                                </form>
                            </ValidationObserver>
                        </div>
                        <div class="card-footer text-right">
                            <limitless-button ref="btnsavetestcard" type="button" @click="saveTestCard" icon="icon-floppy-disk" :busy="busy_saving">Spara</limitless-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';

export default {
    name: 'TestCardEdit',
    components: {
        InputWithValidation,
        SelectWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_saving: false,
        test_card: null,
        test_modes: [
            { label: 'WWW', value: 'WWW' },
            { label: 'PRO', value: 'PRO' },
            { label: 'TOT', value: 'TOT' },
        ],
    }),
    mounted() {
        this.getTestCard();
    },
    watch: {
        id() {
            this.getTestCard();
        },
    },
    methods: {
        getTestCard() {
            this.busy_loading = true;
            apiClient.get('/vue/testcards/' + this.id)
                .then((response) => {
                    this.test_card = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                });
        },
        async saveTestCard() {
            const isValid = await this.$refs.testcardform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/testcards/' + this.test_card.id, { ...this.test_card })
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.id, 10)) {
                            this.$router.push({ name: 'testcards.edit', params: { id: response.data.id } });
                        }
                        this.test_card = response.data;
                        this.$refs.btnsavetestcard.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.testcardform.setErrors(parsederror);
                        }
                        this.$refs.btnsavetestcard.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavetestcard.triggerFailed();
            }
        },
    },
    computed: {
        title() {
            return this.test_card && this.test_card.id > 0 ? this.test_card.alias : 'Nytt testkort';
        },
        title_id() {
            return this.test_card && this.test_card.id > 0 ? this.test_card.id : '';
        },
    },
};
</script>
